module.exports = __webpack_public_path__ + "img/large-logo.5595c71c.png";